import {Box} from "@mui/material";
import {getScaledUrl, MediaSize} from "crqlar-react-common/dist/utils/media.util";
import {Link as RouterLink} from "react-router-dom";
import {useMe} from "../../common/useMe";
import {
    SIDEBAR_ACTION_ICON_SLOT_WIDTH,
    SIDEBAR_CONTENT_X_PADDING,
    SIDEBAR_HEADER_HEIGHT,
} from "./sidebarLayout";

interface SidebarHeaderProps {
    expanded: boolean;
}

const SidebarHeader = ({expanded}: SidebarHeaderProps) => {
    const {organization} = useMe();
    const organizationLogoSrc = getScaledUrl(
        organization?.logo,
        MediaSize.MEDIUM_300,
        MediaSize.MEDIUM_300
    );
    const hasOrganizationLogo = !!organizationLogoSrc;
    const logoSrc = organizationLogoSrc || "/favicon-96x96.png";
    const label = organization?.name || "Crqlar";

    return (
        <Box
            component={RouterLink}
            to="/"
            aria-label={label}
            sx={{
                height: SIDEBAR_HEADER_HEIGHT,
                px: `${SIDEBAR_CONTENT_X_PADDING}px`,
                display: "flex",
                alignItems: "center",
                gap: expanded && !hasOrganizationLogo ? 1 : 0,
                color: "text.primary",
                textDecoration: "none",
                flexShrink: 0,
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    width: SIDEBAR_ACTION_ICON_SLOT_WIDTH,
                    height: SIDEBAR_ACTION_ICON_SLOT_WIDTH,
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Box
                        component="img"
                        src={logoSrc}
                        alt=""
                        sx={{
                            display: "block",
                            maxWidth: "100%",
                            maxHeight: "100%",
                            width: "auto",
                            height: "auto",
                            objectFit: "contain",
                        }}
                    />
                </Box>
            </Box>

            {!hasOrganizationLogo && (
                <Box
                    sx={{
                        minWidth: 0,
                        maxWidth: expanded ? 148 : 0,
                        opacity: expanded ? 1 : 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: 15,
                        fontWeight: 700,
                    }}
                >
                    {label}
                </Box>
            )}
        </Box>
    );
};

export default SidebarHeader;
